import React from 'react'

import { noop } from '#util'

import { BeforeRouteChangeHandler, RouteChangeHandler } from './types'

export const WallabyRouterContext = React.createContext<{
  registerUnloadHandler: (handler: RouteChangeHandler) => () => void
  registerBeforeUnloadHandler: (handler: BeforeRouteChangeHandler) => () => void
  checkUnload: BeforeRouteChangeHandler
  beforeExit: RouteChangeHandler
}>({
  registerUnloadHandler: () => noop,
  registerBeforeUnloadHandler: () => noop,
  checkUnload: () => Promise.resolve({ cancel: false }),
  beforeExit: noop,
})
